'use client';

import Link from 'next/link';
import { useEffect, useMemo, useState } from 'react';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/slw/shared/ui/accordion';
import { CategoriesType } from '@/slw/entities/home/home.model';
import { useResponsive } from '@/slw/shared/hooks/use-responsive';

export function Categories({ categories }: { categories: CategoriesType }) {
  const linkClasses = `py-2 text-base block relative ps-4 before:absolute before:content-[""] before:w-[6px]
  before:h-[6px] before:rounded-full before:bg-foreground before:left-0 before:top-1/2 before:-translate-y-1/2`;

  const { isMaxSm } = useResponsive();

  const accordionItems = useMemo(() => categories.map((_, idx) => `acc${idx}`), [categories]);
  const [openItems, setOpenItems] = useState<string[]>([]);

  useEffect(() => {
    // On mobile: start with all filters collapsed
    // On larger screens: keep all groups expanded by default
    if (isMaxSm) {
      setOpenItems([]);
    } else {
      setOpenItems(accordionItems);
    }
  }, [isMaxSm, accordionItems]);

  return (
    <section
      className='rounded-[8px] bg-sidebar border border-primary/10 p-[15px_15px] md:p-[30px_25px]
      max-h-[60vh] overflow-y-auto md:max-h-none md:overflow-visible'
    >
      <Accordion type='multiple' value={openItems} onValueChange={setOpenItems}>
        {categories.map((item, idx) => (
          <AccordionItem key={idx} value={`acc${idx}`} className='border-none'>
            <AccordionTrigger className='font-[600] text-[1.125rem] border-b border-[#EAE9E5] py-1'>
              {item.name}
            </AccordionTrigger>
            <AccordionContent className='py-4 md:py-6'>
              <ul className='list-none pl-2'>
                {item.children.map((child, subIdx) => (
                  <li key={`${idx}_${subIdx}`}>
                    <Link href={child.href} className={linkClasses}>
                      {child.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
